<capra-toast
  type="success"
  [inline]="true"
  [showCloseBtn]="true"
  [canTapToDismiss]="false"
  (dismissToast)="dismissToast()"
>
  <div class="export-dataset-success-content">
    <p class="success-message">Your dataset is ready</p>
    <a
      class="capra-button secondary link size-small color-neutral location-icon-left"
      [attr.aria-label]="null"
      [modeLegacyRouterLink]="exportedDatasetLink"
      (click)="dismissToast()"
      href="#"
      data-test="capra-button-link"
      rel="noopener noreferrer"
    >
      View
    </a>
  </div>
</capra-toast>
